import { render, staticRenderFns } from "./positionManagement.vue?vue&type=template&id=57d0672f&"
import script from "./positionManagement.vue?vue&type=script&lang=js&"
export * from "./positionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports